import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import './Auth.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const calledRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    if (calledRef.current) return;
    calledRef.current = true;

    api.get(`/api/auth/verify-email/${token}`)
      .then((data) => {
        setStatus('success');
        setMessage(data.message || 'Email verified successfully.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error?.message || 'Verification failed. The link may be expired.');
      });
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/hd-plus-rcm-logo.png" alt="HD Plus RCM Logo" className="auth-logo-img" />
        </div>

        <div className="success-card-content">
          {status === 'verifying' && (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                <div className="loading-spinner" />
              </div>
              <h2>Verifying your email...</h2>
              <p>Please wait a moment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h2>Email Verified</h2>
              <p>{message}</p>
              <Link to="/login" className="back-to-login">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                Continue to Sign In
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="success-icon" style={{ background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </div>
              <h2>Verification Failed</h2>
              <p>{message}</p>
              <Link to="/login" className="back-to-login">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                Back to Sign In
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="auth-page-footer">
        <p>&copy; 2026 Revenue Cycle Management. All rights reserved.</p>
      </div>
    </div>
  );
}

export default VerifyEmail;
